import { render, staticRenderFns } from "./CuponsList.vue?vue&type=template&id=57b3d59f&"
import script from "./CuponsList.vue?vue&type=script&lang=js&"
export * from "./CuponsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports